import { INormalizeByInput, INormalizeBySetting } from "models";

/**
 * The chart's local setting wins field by field over the global one. The well
 * card's Production Array sends the same input, so the two cannot disagree on
 * what "normalized" means.
 */
export const buildNormalizeByInput = (
  useNormalizeBy: Maybe<boolean>,
  local: Maybe<INormalizeBySetting>,
  global: INormalizeBySetting
): INormalizeByInput => ({
  useNormalizeBy: useNormalizeBy ?? false,
  field: local?.field ?? global.field,
  displayName: local?.display ?? global.display,
  per: local?.per ?? global.per,
  unit: local?.unit ?? global.unit,
  defaultUnit: local?.defaultUnit ?? global.defaultUnit ?? "",
  useMultilinearNormalization:
    local?.useMultilinearNormalization ?? global.useMultilinearNormalization,
  threshold: local?.threshold ?? global.threshold,
  lowerScalar: local?.lowerScalar ?? global.lowerScalar,
  higherScalar: local?.higherScalar ?? global.higherScalar
});
